import {
    assign,
    isObject
} from '@emav-util/obj';
function BizWarn(value) {
    if (value instanceof BizWarn) {
        return value;
    }
    if (typeof value === 'number') {
        this.code = value;
    } else if (typeof value === 'string') {
        this.message = value;
    } else if (isObject(value)) {
        if (typeof value.code === 'number') {
            this.code = value.code;
        }
        assign(this, value);
    }
    if (!this.message) {
        this.message = BizWarn.defaultMessages[this.code] || '';
    }
}
BizWarn.prototype.code = 0;
BizWarn.prototype.message = '';
BizWarn.warnTypes = ['BIZ_WARN_PARAMETERS'];
BizWarn.defaultMessages = {
    1: '参数错误',
    2: ''
};
for (var errNum = 0; errNum < BizWarn.warnTypes.length; errNum++) {
    BizWarn[BizWarn.warnTypes[errNum]] = errNum;
    BizWarn.prototype[BizWarn.warnTypes[errNum]] = errNum;
}
export default BizWarn;